import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-split-left, rules, direction, split"} maskId="square-filled-radius-0-stroke-1-IconArrowSplitLeft"><path d="M10 4H4.70703L12.207 11.5H21V12.5H12.207L4.70703 20H10V21H3V14H4V19.293L11.293 12L4 4.70703V10H3V3H10V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowSplitLeft;
